import React, { useCallback } from 'react';
import { Button, Icon } from '@iq/react-components';
import { useDispatch, useSelector } from 'react-redux';

import { getLayout, updateLayout, notifyPageChanges } from '../../../../../bundles/layouts';
import { getActiveSite } from '../../../../../bundles/sites';

import TypeLabel from '../../../../TypeLabel';
import ItemHandler from '../ItemHandler';
import StyledItem from '../../../../StyledItem';

const PageItem = ({
  title,
  path,
  movePage,
  index,
  pageCount,
  selectPage,
  isPublic,
  duplicatePages,
  pages,
}) => {
  const site = useSelector(getActiveSite);
  const layout = useSelector((state) => getLayout(state, site.id));
  const dispatch = useDispatch();
  const onSelectPage = useCallback(() => {
    selectPage(index);
  }, [index]);

  const toggleIcon = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      const updatedPages = pages.map((page, index_) =>
        index_ === index ? { ...page, isPublic: !page.isPublic } : page
      );
      dispatch(updateLayout(site.id, { ...layout, pages: updatedPages }));
      if (isPublic) {
        dispatch(notifyPageChanges('privatePage'));
      } else {
        dispatch(notifyPageChanges('publicPage'));
      }
    },
    [index, pages]
  );

  return (
    <StyledItem
      itemClass="page-list-item"
      isPublic={isPublic}
      headerLabel={
        <>
          <Button
            className="button"
            design="text"
            tooltip={isPublic ? 'Visible to site users' : 'Hidden to site users'}
            tooltipPosition="bottom-end"
            onClick={toggleIcon}
            slim
          >
            <Icon
              icon={isPublic ? 'he-preview' : 'he-preview-off'}
              size="s"
              className={isPublic ? 'isPublic' : 'isPrivate'}
            />
          </Button>
          <TypeLabel type="page" />
        </>
      }
      headerContent={
        <>
          <div className="title">{title}</div>
          <div className="path">{path}</div>
        </>
      }
      headerActions={
        <>
          <ItemHandler
            move={movePage}
            index={index}
            count={pageCount}
            duplicatePages={duplicatePages}
            showDuplicateIcon={true}
          />

          <Icon
            icon="keyboard-arrow-right"
            size="m"
          />
        </>
      }
      onClick={onSelectPage}
    ></StyledItem>
  );
};

export default PageItem;
